import { matchPath } from 'react-router-dom';

import urls from './urls';

const PUBLIC_ROUTE_PATTERNS = [
  urls.verifyAdditonalEmail,
  urls.confirmPhoneNumber,
  urls.confirmationCode,
  urls.location,
  urls.requestAccess,
  urls.companyProfile,
  '/company/:companyName/jobs',
  '/company/:companyName/jobs/*',
  '/job/:jobId',
  '/job/details/:jobId',
  urls.urlProfile,
  urls.candidateStrengthenQuestions,
  urls.companyReferral,
  urls.companyReferralStrengthen,
  urls.companyReferralSuccess,
  urls.refer,
  urls.referralFlowStrengthen,
  urls.referralFlowSuccess,
  urls.companyApplicationFlow,
  urls.companyApplicationFlowStrengthen,
  urls.companyApplicationFlowSuccess,
  urls.organizationSignup,
  urls.unsubscribe,
];

export const isPublicPath = (pathname) =>
  PUBLIC_ROUTE_PATTERNS.some((route) => matchPath({ path: route, end: true }, pathname));

export default PUBLIC_ROUTE_PATTERNS;
